import { ScaleLinear } from 'd3';

export interface IBarPoint {
  name: number;
  value: number;
  extra: {
    pointAnomalous?: boolean;
    areaMax?: number;
    training_data_max?: number;
    hideTooltip?: boolean;
    tooltipData: any;
  };
}

export type IBarPoints = Array<IBarPoint>;

export interface IStackedBarPoint extends IBarPoint {
  stackedData: number[]; // Specify data in order of moving from top to bottom for a bar graph
}

export type IStackedBarPoints = Array<IStackedBarPoint>;

export enum BarVariant {
  NORMAL,
  GRADIENT,
  STACKED
}

export type XScale = ScaleLinear<number, number>;
export type YScale = ScaleLinear<number, number>;

export interface ChartDimensions {
  chartWidth: number;
  chartHeight: number;
}

